// extracted by mini-css-extract-plugin
export default {"templatesListLayout":"TemplatesListLayout_templatesListLayout__8e0VV"};